import clsx from 'clsx';

/*
size = int (pixels)
color = tailwind color class
bgColor = tailwind color class
 */
export const CircleProgressBar = ({
                                    value = 0, maxValue = 1, unit = '%', size = 150,
                                    valueSize = 'text-3xl', valueColor = 'text-white',
                                    text= null, textSize = 'text-3xl', textColor = 'text-white',
                                    color = 'stroke-perception-blue', bgColor = 'stroke-perception-black-500',
                                    hideStroke = false,
                                    className, ...props
}) => {
  const progress = Math.min(value, maxValue) / maxValue;

  const r = Math.floor(0.8 * size) / 2;
  const strokeWidth = 0.08 * size;

  return (
    <div className={clsx(className, 'flex flex-col items-center justify-center w-full')}>
      <div className="relative flex justify-center items-center" style={{ width: size, height: size }}>
        <svg className={`${hideStroke && 'opacity-0'} -rotate-90`} viewBox={`0 0 ${size} ${size}`} style={{ width: size, height: size }}>
          <circle cx={size/2} cy={size/2} r={r} fill="none" className={bgColor} strokeWidth={strokeWidth} />
          <circle cx={size/2} cy={size/2} r={r} fill="none" className={color} strokeWidth={strokeWidth} strokeLinecap="round"
                  strokeDasharray={2 * Math.PI * r}
                  strokeDashoffset={(2 * Math.PI * r) * (1 - progress)}
          />
        </svg>

        <div className="absolute inset-0 flex justify-center items-center">
          <span className={`${valueSize} ${valueColor}`}>
            { unit === '%' ? Math.floor(progress * 100) + unit : value}
          </span>
        </div>
      </div>

      {text &&
        <div className={`${textSize} ${textColor} text-center`}>
          {text}
        </div>
      }
    </div>
  );
};
